import React from "react";
import BaseComponent from "../BaseComponent.js";
import { Redirect } from "react-router";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import searchService from "../../services/SearchService.js";
import playlistService from "../../services/PlaylistService.js";

import Type from "../Global/Typography.js";
import NanoFlex from "./../Global/NanoFlex";
import MenuMobile from "./MenuMobile";

import AdvancedSearch from "./../layouts/AdvancedSearch.js";

import glanceNav from "./../../images/glanceNav.svg";
import { ReactComponent as AdvancedSearchIcon } from "../Global/Icons/advancedSearch.svg";
import { ReactComponent as EditorialReports } from "../Global/Icons/editorialReports.svg";
import { ReactComponent as Playlist } from "../Global/Icons/playlist.svg";
import { ReactComponent as SavedSearches } from "../Global/Icons/savedSearches.svg";
import { ReactComponent as Vip } from "../Global/Icons/vip.svg";
import { ReactComponent as AudienceBoosters } from "../Global/Icons/audienceBoosters.svg";
import { ReactComponent as LatestProgrammes } from "../Global/Icons/latestProgrammes.svg";
import { ReactComponent as UpcomingProgrammes } from "../Global/Icons/upcomingProgrammes.svg";
import { ReactComponent as Favorite } from "../Global/Icons/favCrown.svg";
import { ReactComponent as DoubleArrows } from "../Global/Icons/doubleArrowLeft.svg";
import { ReactComponent as Share } from "../Global/Icons/share.svg";
import { ReactComponent as BurguerMenu } from "../Global/Icons/burguerMenu.svg";
import { ReactComponent as Close } from "../Global/Icons/close.svg";
import vipService from "../../services/VipService.js";

const multiple = nota.global.multiple;

const StyledNavbarWrapper = styled(NanoFlex)`
  width: ${(props) => (props.isCollapsed ? nota.global.grid.navbarWrapper.collapsedWidth : nota.global.grid.navbarWrapper.expandedWidth) + (props.advancedSearchVisible ? nota.global.grid.advancedSearch.width : 0) + "px"};
  /* margin-right: 20px; */
  position: relative;
  .navBarContainer {
    width: auto;
    width: ${(props) => (props.isCollapsed ? nota.global.grid.navbarWrapper.collapsedWidth : nota.global.grid.navbarWrapper.expandedWidth) + (props.advancedSearchVisible ? nota.global.grid.advancedSearch.width : 0) + "px"};
  }
  /* COLLAPSED NAV */
  .collapsedNav {
    .navBar {
      width: 65px;
      aside {
        .navListContainer {
          .navBarList {
            .navBarItem {
              justify-content: center;
              padding: 4px 8px;
              p {
                display: none;
              }
              .notificationNavBar {
                padding: 4px;
                background-color: ${nota.color.main.mOne};
                position: absolute;
                width: 12px;
                right: 0;
                border-radius: 30px 0 0 30px;
                .numberWrapper {
                  display: none;
                }
                .iconWrapper {
                  margin-left: 0;
                  svg {
                    height: 8px;
                    path {
                      fill: ${nota.color.neutral.white};
                    }
                  }
                }
              }
            }
          }
          .headerNav {
            .navFavHeader {
              justify-content: center;
              p {
                display: none;
              }
            }
          }
        }
        .logoWrapper {
          a {
            img {
              width: 45px;
            }
          }
        }
        .collapseBtn {
          svg {
            height: 10px;
            width: auto;
            transform: rotate(180deg);
          }
        }
      }
    }

    .advancedSearchMenu {
      .advancedSearchContainer {
        margin-left: 65px;
      }
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    width: auto;
    .navBarContainer {
      width: 100%;
    }
    .collapsedNav {
      width: 100%;
      .navBar {
        width: 100%;
      }
      .advancedSearchMenu {
        .advancedSearchContainer {
          margin-left: 0;
        }
      }
    }
  }
`;

const StyledNavbar = styled(NanoFlex)`
  display: flex;
  width: ${nota.global.grid.navBar.width};
  height: 100%;
  position: fixed;
  z-index: 3;
  left: 0;
  top: 0;

  aside {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background: ${nota.color.neutral.NeuFour};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding-top: ${multiple * 6 + "px"};
    .navListContainer {
      min-height: -webkit-fit-content;
    }

    .navBarList {
      border-bottom: 1px solid ${nota.color.neutral.NeuThree};
      height: auto;
      padding: ${multiple * 2 + "px"} 0;

      .navBarItem {
        cursor: pointer;
        height: ${multiple * 4 + "px"};
        /* padding: 0px ${multiple + "px"}; */
        padding: 4px 0px 4px 8px;
        -webkit-user-select: none; /* Chrome all / Safari all */
        -moz-user-select: none; /* Firefox all */
        -ms-user-select: none; /* IE 10+ */
        user-select: none; /* Likely future */
        position: relative;
        margin-bottom: 2px;
        svg {
          width: 16px;
          height: 16px;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
        p {
          font-size: 13px;
          margin-left: ${multiple + "px"};
          color: ${nota.color.neutral.NeuOne};
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .notificationNavBar {
          width: auto;
          background-color: ${nota.color.neutral.lightGrey};
          border-radius: 50px 0 0 50px;
          padding: 4px 8px;
          .numberWrapper {
            background-color: ${nota.color.main.mOne};
            border-radius: 50px;
            width: 20px;
            height: 20px;
            /* padding:  ${multiple / 2 + "px"};  */
            h6 {
              color: ${nota.color.neutral.white};
            }
          }
          .iconWrapper {
            width: auto;
            margin-left: ${multiple + "px"};
            svg {
              height: 13px;
              width: auto;
              path {
                fill: ${nota.color.main.mOne};
              }
            }
          }
        }

        &:hover {
          background-color: ${nota.color.neutral.white};
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      &:last-child {
        border-bottom: 0px;
      }

      .activeBarItem {
        background: ${nota.color.neutral.white};
        svg {
          path {
            fill: ${nota.color.main.default};
          }
          p {
            color: ${nota.color.main.mOne};
          }
        }
      }
    }
    .headerNav {
      padding-top: 0;
      border-bottom: 0;
      .navFavHeader {
        height: auto;
        margin-bottom: 8px;
        padding: ${multiple + "px"};
        background-color: ${nota.color.neutral.NeuFive};
        user-select: none;
        p {
          text-transform: uppercase;
          font-size: 12px;
        }
        svg {
          height: 14px;
          width: auto;
          path {
            fill: ${nota.color.main.mThree};
          }
        }
      }
    }
    .logoWrapper {
      padding-bottom: 20px;
      a {
        img {
          height: 35px;
        }
      }
    }

    .collapseBtn {
      height: auto;
      min-height: -webkit-fit-content;
      cursor: pointer;
      padding: 10px;
      background-color: ${nota.color.neutral.NeuFive};

      svg {
        height: 12px;
        width: auto;
      }
    }

    .activeAS {
      position: relative;
      .navBarItem {
        svg {
          .gear {
            fill: ${nota.color.main.mOne};
          }
        }
        p {
          color: ${nota.color.main.mOne};
        }
      }
      &:after {
        content: "";
        position: absolute;
        left: 100%;
        top: 50%;
        display: block;
        border-right: 2px solid ${nota.color.neutral.white};
        border-bottom: 2px solid ${nota.color.neutral.white};
        background-color: ${nota.color.neutral.white};
        width: 15px;
        height: 15px;
        transform: translate(-50%, -50%) rotate(-135deg);
      }
    }
    .selectedAS {
      .navBarItem {
        svg {
          .gear {
            fill: ${nota.color.main.mOne};
          }
        }
      }
    }
  }

  .orderFlex1 {
    order: 1;
  }

  .orderFlex2 {
    order: 2;
  }
  .orderFlex3 {
    order: 3;
  }
  .orderFlex4 {
    order: 4;
  }
  .orderFlex5 {
    order: 3;
  }

  .mobileShow {
    display: none;
  }

  /* MEDIA QUERIES */

  @media only screen and (max-height: 700px) {
    .listContainer {
      justify-content: flex-start;
      max-height: calc(100vh - 90vh);
      overflow: overlay;
    }
  }
  @media only screen and (max-width: 800px) {
    width: 100%;
    height: auto;
    bottom: 0;
    z-index: 10;
    top: auto;
    .asideContainer {
      padding-top: 0;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      .navListContainer {
        flex-direction: row;

        .navBarList {
          flex-direction: row;
          border-left: 1px solid #d9d9d9;
          border-bottom: none;
          justify-content: space-around;
          padding: ${multiple / 2 + "px"};
          /* padding:0; */
          .navBarItem {
            width: auto;
            padding: 8px 16px;
            margin-right: 4px;

            svg {
              width: auto;
              max-width: 20px;
              height: 18px;
            }
            .notificationNavBar {
              padding: 4px;
              background-color: ${nota.color.main.mOne};
              position: absolute;
              width: 14px;
              height: 14px;
              right: 8px;
              top: 12px;
              border-radius: 30px;
              .numberWrapper {
                display: none;
              }
              .iconWrapper {
                margin-left: 0;
                svg {
                  height: 8px;
                  path {
                    fill: ${nota.color.neutral.white};
                  }
                }
              }
            }
            &:last-child {
              margin-right: 0px;
            }
            &:hover {
              background-color: unset;
            }
          }
          .activeBarItem {
            /* background-color: ${nota.color.neutral.NeuFive}; */
            background-color: unset;
          }
        }
        .activeAS {
          background-color: ${nota.color.neutral.NeuFive};
          .navBarItem {
            svg {
              path {
                fill: ${nota.color.main.default};
              }
              .gear {
                fill: ${nota.color.main.mOne};
              }
            }
          }
          &:after {
            display: none;
          }
        }
        .toCloseMenu {
          background-color: ${nota.color.neutral.NeuFive};
          .navBarItem {
            svg {
              path {
                fill: ${nota.color.main.mOne};
              }
            }
          }
        }
        .orderFlex1 {
          order: 2;
          width: 33%;
          .navBarItem {
            width: 100%;
            justify-content: center;
          }
        }

        .orderFlex2 {
          order: 1;
          flex-direction: row-reverse;
        }

        .orderFlex5 {
          width: 33%;
          .navBarItem {
            width: 100%;
            justify-content: center;
          }
        }
      }
    }

    .mobileHide {
      display: none;
    }
    .mobileShow {
      display: flex;
    }
  }
`;

class Navbar extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearchVisible: this.props.advancedSearchVisible ? this.props.advancedSearchVisible : false,
      isCollapsed: JSON.parse(localStorage.getItem("isNavbarCollapsed")) ?? false,

      redirectTo: "",
      accountMenu: "",

      savedSearches: null,
      playlistsNotificationCount: null,

      preventAdvancedSearchCallback: false,

      menuMobileVisible: false,
      hasReports: false,
    };

    this.reloadAdvancedSearchVisibleSession();
  }

  componentDidMount() {
    super.componentDidMount();
    this.getSavedSearches();
    this.getPlaylistsNotificationCount();
    this.getHasReports();
    window.addEventListener("reloadNavbarSavedSearches", this.onReloadNavbarSavedSearches, false);
    window.addEventListener("reloadNavbarPlaylistsNotificationCount", this.onReloadNavbarPlaylistsNotificationCount, false);
    window.addEventListener("closeAdvancedSearch", this.onCloseAdvancedSearch, false);
    window.addEventListener("openAdvancedSearch", this.onOpenAdvancedSearch, false);
    window.addEventListener("toggleAdvancedSearch", this.onToggleAdvancedSearch, false);
    window.addEventListener("setSearchFrom", this.onSetSearchFrom, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.advancedSearchVisible !== prevState.advancedSearchVisible && this.props.onAdvancedSearchVisibleChange) {
      if (!this.state.preventAdvancedSearchCallback) {
        this.props.onAdvancedSearchVisibleChange(this.state.advancedSearchVisible);
      } else {
        this.setState({ preventAdvancedSearchCallback: false });
      }
    }

    if (this.state.redirectTo) this.setState({ redirectTo: "" });

    if (this.state.advancedSearchVisible !== prevState.advancedSearchVisible || this.state.isCollapsed !== prevState.isCollapsed) {
      window.dispatchEvent(new Event("resize"));
    }

    if (this.props.render.match.path === "/playlists" && this.state.playlistsNotificationCount > 0) {
      this.markSharedPlaylistsAsSeen();
    }

    if (this.state.isCollapsed !== prevState.isCollapsed) {
      localStorage.setItem("isNavbarCollapsed", this.state.isCollapsed);
    }

    if (JSON.stringify(this.props.render.match) !== JSON.stringify(prevProps.render.match)) {
      this.setState({ menuMobileVisible: false });
    }

    if (this.state.advancedSearchVisible !== prevState.advancedSearchVisible) {
      this.reloadAdvancedSearchVisibleSession();
      window.dispatchEvent(new Event("advancedSearchVisibleChanged"));
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("closeAdvancedSearch", this.onCloseAdvancedSearch, false);
    window.removeEventListener("openAdvancedSearch", this.onOpenAdvancedSearch, false);
    window.removeEventListener("toggleAdvancedSearch", this.onToggleAdvancedSearch, false);
    window.removeEventListener("setSearchFrom", this.onSetSearchFrom, false);
  }

  reloadAdvancedSearchVisibleSession = () => {
    sessionStorage.setItem("advancedSearchVisible", this.state.advancedSearchVisible);
  };

  onCloseAdvancedSearch = () => {
    this.setState({ advancedSearchVisible: false, preventAdvancedSearchCallback: true });
  };

  onOpenAdvancedSearch = () => {
    this.setState({ advancedSearchVisible: true, preventAdvancedSearchCallback: true });
  };

  onToggleAdvancedSearch = () => {
    this.setState({ advancedSearchVisible: !this.state.advancedSearchVisible, preventAdvancedSearchCallback: true });
  };

  onReloadNavbarSavedSearches = () => {
    this.getSavedSearches();
  };

  onReloadNavbarPlaylistsNotificationCount = () => {
    this.getPlaylistsNotificationCount();
  };

  getSavedSearches = () => {
    searchService
      .getFavoritesSavedSearches()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ savedSearches: data });
      });
  };

  getPlaylistsNotificationCount = () => {
    playlistService
      .getUnseenSharedPlaylistCount()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlistsNotificationCount: data });
      });
  };

  getHasReports = () => {
    vipService
      .hasReports()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ hasReports: data });
      });
  };

  markSharedPlaylistsAsSeen = () => {
    playlistService
      .markSharedPlaylistsAsSeen()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlistsNotificationCount: 0 });
      });
  };

  advancedSearchClick = () => {
    let newAdvancedSearchVisible = !this.state.advancedSearchVisible;
    this.setState({ advancedSearchVisible: newAdvancedSearchVisible, menuMobileVisible: newAdvancedSearchVisible ? false : this.state.menuMobileVisible });
  };

  redirectTo = (url) => {
    this.setState({ redirectTo: url });
  };

  toggleCollapse = () => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  toggleMenuMobile = () => {
    let newMenuMobileVisible = !this.state.menuMobileVisible;
    this.setState({ menuMobileVisible: newMenuMobileVisible, advancedSearchVisible: newMenuMobileVisible ? false : this.state.advancedSearchVisible });
  };

  closeMenuMobile = () => {
    this.setState({ menuMobileVisible: false });
  };

  onSetSearchFrom = () => {
    this.setState({ menuMobileVisible: false });
  };

  render() {
    if (this.state.redirectTo) return <Redirect to={this.state.redirectTo} />;

    return (
      <StyledNavbarWrapper advancedSearchVisible={this.state.advancedSearchVisible} isCollapsed={this.state.isCollapsed} className="navBarWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className={`navBarContainer ${this.state.isCollapsed ? "collapsedNav" : ""}`} flexDirection={"row"}>
          <StyledNavbar className="navBar">
            <aside className="asideContainer">
              <NanoFlex className="navListContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex
                  className={`navBarList orderFlex1 ${this.state.advancedSearchVisible ? "activeAS" : ""} ${!this.state.advancedSearchVisible && this.props.selectedMenu === "AdvancedSearch" ? "selectedAS" : ""}`}
                  title={this.translation.navBar.advancedSearch}
                  flexDirection={"column"}
                  alignItems={"flex-start"}
                  onClick={this.advancedSearchClick}>
                  <NanoFlex className="navBarItem" justifyContent={"flex-start"}>
                    <AdvancedSearchIcon />
                    <Type.p className="mobileHide">
                      <b>{this.translation.navBar.advancedSearch}</b>
                    </Type.p>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="navBarList orderFlex2" flexDirection={"column"} alignItems={"flex-start"}>
                  {this.state.hasReports && (
                    <NanoFlex
                      className={`navBarItem ${this.props.render.match.path === "/reports" && !this.props.selectedMenu ? "activeBarItem" : ""}`}
                      title={this.translation.navBar.notaReports}
                      justifyContent={"flex-start"}
                      onClick={() => {
                        this.redirectTo("/Reports");
                      }}>
                      <EditorialReports />
                      <Type.p className="mobileHide">
                        <b>{this.translation.navBar.notaReports}</b>
                      </Type.p>
                    </NanoFlex>
                  )}
                  <NanoFlex
                    className={`navBarItem ${this.props.render.match.path === "/playlists" && !this.props.selectedMenu ? "activeBarItem" : ""}`}
                    title={this.translation.navBar.playlists}
                    justifyContent={"flex-start"}
                    onClick={() => {
                      this.redirectTo("/Playlists");
                    }}>
                    <NanoFlex>
                      <Playlist />
                      <Type.p className="mobileHide">
                        <b>{this.translation.navBar.playlists}</b>
                      </Type.p>
                    </NanoFlex>
                    {this.state.playlistsNotificationCount > 0 && (
                      <NanoFlex className="notificationNavBar">
                        <NanoFlex className="numberWrapper">
                          <Type.h6>{this.state.playlistsNotificationCount}</Type.h6>
                        </NanoFlex>
                        <NanoFlex className="iconWrapper">
                          <Share />
                        </NanoFlex>
                      </NanoFlex>
                    )}
                  </NanoFlex>
                  <NanoFlex
                    className={`navBarItem ${this.props.render.match.path === "/savedSearches" && !this.props.selectedMenu ? "activeBarItem" : ""}`}
                    title={this.translation.navBar.savedSearches}
                    justifyContent={"flex-start"}
                    onClick={() => {
                      this.redirectTo("/SavedSearches");
                    }}>
                    <SavedSearches />
                    <Type.p className="mobileHide">
                      <b>{this.translation.navBar.savedSearches}</b>
                    </Type.p>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="navBarList mobileHide orderFlex3" flexDirection={"column"} alignItems={"flex-start"}>
                  <NanoFlex
                    className={`navBarItem ${this.props.selectedMenu === "NotaSelection" ? "activeBarItem" : ""}`}
                    title={this.translation.navBar.notaSelection}
                    justifyContent={"flex-start"}
                    onClick={() => {
                      if (this.props.selectedMenu !== "NotaSelection") {
                        window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "NotaSelection" } }));
                      }
                    }}>
                    <Vip />
                    <Type.p>
                      <b>{this.translation.navBar.notaSelection}</b>
                    </Type.p>
                  </NanoFlex>
                  <NanoFlex
                    className={`navBarItem ${this.props.selectedMenu === "AudienceBooster" ? "activeBarItem" : ""}`}
                    title={this.translation.navBar.audienceBoosters}
                    justifyContent={"flex-start"}
                    onClick={() => {
                      if (this.props.selectedMenu !== "AudienceBooster") {
                        window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "AudienceBooster" } }));
                      }
                    }}>
                    <AudienceBoosters />
                    <Type.p>
                      <b>{this.translation.navBar.audienceBoosters}</b>
                    </Type.p>
                  </NanoFlex>
                  <NanoFlex
                    className={`navBarItem ${this.props.selectedMenu === "Latest" ? "activeBarItem" : ""}`}
                    title={this.translation.navBar.latestProgrammes}
                    justifyContent={"flex-start"}
                    onClick={() => {
                      if (this.props.selectedMenu !== "Latest") {
                        window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Latest" } }));
                      }
                    }}>
                    <LatestProgrammes />
                    <Type.p>
                      <b>{this.translation.navBar.latestProgrammes}</b>
                    </Type.p>
                  </NanoFlex>
                  <NanoFlex
                    className={`navBarItem ${this.props.selectedMenu === "Upcoming" ? "activeBarItem" : ""}`}
                    title={this.translation.navBar.upcomingProgrammes}
                    justifyContent={"flex-start"}
                    onClick={() => {
                      if (this.props.selectedMenu !== "Upcoming") {
                        window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Upcoming" } }));
                      }
                    }}>
                    <UpcomingProgrammes />
                    <Type.p>
                      <b>{this.translation.navBar.upcomingProgrammes}</b>
                    </Type.p>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="navBarList headerNav mobileHide orderFlex4" flexDirection={"column"} alignItems={"flex-start"}>
                  {this.state.savedSearches?.length > 0 && (
                    <NanoFlex className="navFavHeader" title={this.translation.navBar.favorites} justifyContent="space-between">
                      <Type.p>{this.translation.navBar.favorites}</Type.p>
                    </NanoFlex>
                  )}
                  <NanoFlex className="listContainer" flexDirection={"column"} alignItems={"flex-start"}>
                    {this.state.savedSearches &&
                      this.state.savedSearches.map((item) => {
                        return (
                          <NanoFlex
                            key={"savedSearches_" + item.id}
                            title={item.searchName}
                            className={`navBarItem ${this.props.selectedMenu === "SavedSearch" && item.id === this.props.savedSearchId ? "activeBarItem" : ""}`}
                            justifyContent={"flex-start"}
                            onClick={(e) => {
                              window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { id: item.id, menu: "SavedSearch", lastCall: item.lastCall, filter: JSON.parse(JSON.stringify(item.filter)) } }));
                            }}>
                            <SavedSearches />
                            <Type.p>
                              <b>{item.searchName}</b>
                            </Type.p>
                          </NanoFlex>
                        );
                      })}
                  </NanoFlex>
                </NanoFlex>

                <NanoFlex className={`navBarList mobileShow orderFlex5 ${this.state.menuMobileVisible ? "toCloseMenu" : ""}`} flexDirection={"column"} alignItems={"flex-start"}>
                  <NanoFlex className="navBarItem" justifyContent={"flex-start"} onClick={this.toggleMenuMobile}>
                    {!this.state.menuMobileVisible && <BurguerMenu />}
                    {this.state.menuMobileVisible && <Close />}
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
              <NanoFlex className="logoWrapper mobileHide" alignItems={"flex-end"}>
                <a href="https://www.glance-mediametrie.com/" rel="noopener noreferrer" target="_blank">
                  <img src={glanceNav} alt="Glance Logo Navbar" />
                </a>
              </NanoFlex>
              <NanoFlex className="collapseBtn mobileHide" onClick={this.toggleCollapse}>
                <DoubleArrows />
              </NanoFlex>
            </aside>
          </StyledNavbar>
          <AdvancedSearch className={"advancedSearchMenu"} visible={this.state.advancedSearchVisible} onAdvancedSearchChange={this.props.onAdvancedSearchChange} onAdvancedSearchSave={this.props.onAdvancedSearchSave} />
          {this._isMobile && <MenuMobile visible={this.state.menuMobileVisible} savedSearches={this.state.savedSearches} render={this.props.render} selectedMenu={this.props.selectedMenu} savedSearchId={this.props.savedSearchId} closeMenuMobile={this.closeMenuMobile} />}
        </NanoFlex>
      </StyledNavbarWrapper>
    );
  }
}

export default Navbar;

// --- // Documentation // --- //
/*
import Navbar from './Navbar.js';

<Navbar />
*/
